window.app.controller('optionsCtrl', ['$scope', function ($scope) {

  $scope.livRegions = [
    { value: "Dolnośląskie Województwo", title: "Dolnośląskie Województwo" },
    { value: "Kujawsko-pomorskie Województwo", title: "Kujawsko-pomorskie Województwo" },
    { value: "Lubelskie Województwo", title: "Lubelskie Województwo" },
    { value: "Lubuskie Województwo", title: "Lubuskie Województwo" },
    { value: "Łódzkie Województwo", title: "Łódzkie Województwo" },
    { value: "Małopolskie Województwo", title: "Małopolskie Województwo" },
    { value: "Mazowieckie Województwo", title: "Mazowieckie Województwo" },
    { value: "Opolskie Województwo", title: "Opolskie Województwo" },
    { value: "Podkarpackie Województwo", title: "Podkarpackie Województwo" },
    { value: "Podlaskie Województwo", title: "Podlaskie Województwo" },
    { value: "Pomorskie Województwo", title: "Pomorskie Województwo" },
    { value: "Śląskie Województwo", title: "Śląskie Województwo" },
    { value: "Świętokrzyskie Województwo", title: "Świętokrzyskie Województwo" },
    { value: "Warmińsko-mazurskie Województwo", title: "Warmińsko-mazurskie Województwo" },
    { value: "Wielkopolskie Województwo", title: "Wielkopolskie Województwo" },
    { value: "Zachodniopomorskie Województwo", title: "Zachodniopomorskie Województwo" },
  ];

  $scope.livStatuses = [
    { value: "rentRoom", title: "Wynajęty pokój" },
    { value: "rentFlat", title: "Wynajęte mieszkanie lub dom" },
    { value: "flatOwner", title: "Właściciel domu lub mieszkania" },
    { value: "withParents", title: "Mieszkający z rodzicami" },
    { value: "communal", title: "Komunalne/Spółdzielcze/lokatorskie" },
    { value: "mortgage", title: "Hipoteczne" },
  ];

  $scope.incomeTypes = [
    { value: "employmentContract", title: "Umowa o pracę" },
    { value: "orderContract", title: "Umowa zlecenie/o dzieło" },
    { value: "entrepreneurialActivity", title: "Działalność gospodarcza" },
    { value: "pensioner", title: "Emeryt" },
    { value: "student", title: "Student" },
    { value: "farm", title: "Gospodarstwo rolne" },
    { value: "housewife", title: "Gospodyni domowa" },
    { value: "unemployed", title: "Bezrobotny" },
    { value: "oddJob", title: "Praca dorywcza" },
    { value: "managerialContract", title: "Kontrakt menadżerski" },
    { value: "benefitReceiver", title: "Rencista" },
    { value: "alimony", title: "Alimenty" },
    { value: "socialBenefits", title: "Świadczenie społeczne" },
  ];

  $scope.occupations = [
    { value: "management", title: "Stanowisko kierownicze" },
    { value: "education", title: "Nauczyciel/edukacja" },
    { value: "medical", title: "Lekarz/inne zawody medyczne" },
    { value: "lawyer", title: "Adwokat/prawnik" },
    { value: "ITSpecialist", title: "IT specjalista/ekspert" },
    { value: "engineer", title: "Inżynier/Technik i inny średni personel" },
    { value: "administration", title: "Administracja/urzędnik państwowy" },
    { value: "sales", title: "Przedstawiciel handlowy/Sprzedawca" },
    { value: "physicalWorker", title: "Pracownik fizyczny" },
    { value: "architect", title: "Architekt" },
    { value: "accountant", title: "Księgowy" },
  ];

  $scope.educationStatuses = [
    { value: "noEducation", title: "Brak wykształcenia" },
    { value: "primary", title: "Wykształcenie podstawowe" },
    { value: "secondary", title: "Wykształcenie średnie" },
    { value: "high", title: "Wykształcenie wyższe" },
    { value: "highMaster", title: "Wykształcenie wyższe magisterskie" },
    { value: "highDoctoral", title: "Wykształcenie wyższe doktorskie" },
    { value: "basicVocational", title: "Zasadnicze zawodowe" },
    { value: "highVocational", title: "Wykształcenie wyższe zawodowe" },
    { value: "degree", title: "Stopień naukowy" },
    { value: "academic", title: "Akademik" },
  ];

  $scope.maritalStatuses = [
    { value: "single", title: "Wolny (kawaler/panna)" },
    { value: "married", title: "Żonaty/zamężna" },
    { value: "divorced", title: "Rozwiedziona/Rozwiedziony" },
    { value: "widowed", title: "Wdowa/Wdowiec" },
    { value: "livingWithPartner", title: "Mieszkasz z partnerem" }
  ];

  $scope.experiences = [
    { value: "to3Month", title: "Mniej niż 3 miesiące" },
    { value: "3to6Months", title: "3-6 miesięcy" },
    { value: "7to12Months", title: "7-12 miesięcy" },
    { value: "1to2Years", title: "1-2 lata" },
    { value: "3to5Years", title: "3-5 lat" },
    { value: "6to10Years", title: "6-10 lat" },
    { value: "11YearsAndMore", title: "11 lub więcej lat" }
  ];

  $scope.banks = [
    {
      value: "pekao",
      title: "Bank Pekao SA",
      imgSrc: "pl-pekao.svg",
      code: [1240]
    },
    {
      value: "zachodni",
      title: "Santander Bank Polska S.A.",
      imgSrc: "pl-bzwbk.svg",
      code: [1090, 1910, 1500]
    },
    {
      value: "ing",
      title: "ING Bank Śląski",
      imgSrc: "pl-ingbank.svg",
      code: [1050]
    },
    {
      value: "mbank",
      title: "mBank",
      imgSrc: "pl-mbank.svg",
      code: [1140]
    },
    {
      value: "ipko",
      title: "PKO Bank Polski",
      imgSrc: "pl-pkobp-nowy.svg",
      code: [1020, 1440]
    },
    {
      value: "millennium",
      title: "Bank Millennium",
      imgSrc: "pl-millennium.svg",
      code: [1160]
    },
    {
      value: "alior",
      title: "Alior Bank",
      imgSrc: "pl-aliorbank.svg",
      code: [2490]
    },
    {
      value: "pocztowy",
      title: "Bank pocztowy",
      imgSrc: "pl-pocztowy.svg",
      code: [1320]
    },
    {
      value: "agricole",
      title: "Credit Agricole",
      imgSrc: "pl-ca.svg",
      code: [1940]
    },
    {
      value: "getin",
      title: "Getin Bank",
      imgSrc: "pl-getinbank.svg",
      code: [1460, 1560]
    },
    {
      value: "bnp",
      title: "Bank BGZ BNP Paribas S.A.",
      imgSrc: "pl-bnpparibas.svg",
      code: [1600, 2030]
    },
    {
      value: "inteligo",
      title: "Inteligo",
      imgSrc: "pl-inteligo.svg",
      code: [1020]
    },
    {
      value: "citibank",
      title: "Bank Handlowy",
      imgSrc: "pl-citibank.svg",
      code: [1030]
    },
    {
      value: "eurobank",
      title: "Euro Bank",
      imgSrc: "pl-eurobank.svg",
      code: [1470]
    },
    {
      value: "nest",
      title: "Nest Bank",
      imgSrc: "pl-nestbank.svg",
      code: [1870, 2530]
    },
    {
      value: "bos",
      title: "Bank Ochrony Środowiska",
      imgSrc: "pl-bosbank.svg",
      code: [1540]
    },
    {
      value: "eskok",
      title: "SKOK",
      imgSrc: "pl-skok.svg",
      code: [7999]
    },
    {
      value: "idea",
      title: "Idea Bank",
      imgSrc: "ideabank.png",
      code: [1950]
    },
    {
      value: "tmobile",
      title: "TMobile",
      imgSrc: "t-mobile.png",
      code: [2490]
    },
    {
      value: "plus",
      title: "Plus",
      imgSrc: "pl-plusbank24.svg",
      code: [1680]
    },
    {
      value: "optima",
      title: "BGŻOptima",
      imgSrc: "optima.png",
      code: [1600]
    },
    {
      value: "raiffeisen",
      title: "Raiffeisen Polbank",
      imgSrc: "pl-raiffeisen.svg",
      code: [1750, 2340]
    },
    {
      value: "orange",
      title: "Kompakt Finanse",
      imgSrc: "pl-mbank.svg",
      code: [1142]
    },
    {
      value: "Konto w innym banku",
      title: "Konto w innym banku",
      imgSrc: "",
      code: []
    }
  ]

  //For bikFish
  $scope.empType = [
    { value: "Full Time Employed", title: "Zatrudniony na pełny etat" },
    { value: "Part Time Employed", title: "Zatrudniony na część etatu" },
    { value: "Fixed Term Contract", title: "Zatrudniony na czas określony" },
    { value: "Self Employed", title: "Przedsięboirca" },
    { value: "Student", title: "Student" },
    { value: "Pensioner", title: "Emeryt" },
    { value: "Housewife/man", title: "Gospodyni(darz) domowa(y)" },
    { value: "Unemployed", title: "Bezrobotny(a)" },
    { value: "Maternity leave", title: "Urlop macierzyński" }
  ];

  $scope.occupationsBIK = [
    { value: "Leading Position", title: "Stanowisko kierownicze" },
    { value: "Teacher / education", title: "Nauczyciel/edukacja" },
    { value: "Doctor / Other medical proffesions", title: "Lekarz/inne zawody medyczne" },
    { value: "Advocate / Lawyer", title: "Adwokat/prawnik" },
    { value: "IT specialist / expert", title: "IT specjalista/ekspert" },
    { value: "Engineer / Technician and other middle staff", title: "Inżynier/Technik i inny średni personel" },
    { value: "Administrative / State employee", title: "Administracja/urzędnik państwowy" },
    { value: "Sales representative / Salesman", title: "Przedstawiciel handlowy/Sprzedawca" },
    { value: "Physical worker", title: "Pracownik fizyczny" },
    { value: "Other", title: "Inne" }
  ];

  $scope.$emit('passBanks', {
    banks: $scope.banks,
  })

}]);




// WEBPACK FOOTER //
// src/js/controllers/singleApplication/optionsCtrl.js